<template>
  <div class="h-full">
    <el-card class="model-edit bg-[rgba(46,107,176,0.5)] w-368px text-white p-10px h-full">
      <div slot="header" class="flex justify-between h-full">
        <span class="text-14px">模型树</span>
      </div>

      <div class="h-45px p-5px mt-5px">
        <el-input
          size="small"
          placeholder="请输入要过滤的设备"
          v-model="filterTreeKeyWords"
          @keypress.native.enter="filterModelTree(0, filterTreeKeyWords)"
          clearable
        >
          <el-button
            slot="append"
            icon="iconfont icon-line-down"
            @click="filterModelTree(currentNodeData.node, filterTreeKeyWords)"
            class="pl-10px pr-10px text-12px"
          ></el-button>
          <el-button
            slot="append"
            icon="iconfont icon-line-up"
            @click="filterModelTree(currentNodeData.node, filterTreeKeyWords)"
            class="pl-10px pr-10px mr-1px text-12px"
          ></el-button>
        </el-input>
      </div>
      <div class="h-[calc(100%-45px)]" v-loading="!treeShow">
        <el-tree
          :props="defaultProps"
          :load="loadNode"
          ref="modelTree"
          id="modelTree"
          node-key="node"
          lazy
          show-checkbox
          highlight-current
          :default-expanded-keys="defaultExpandedKeys"
          :default-checked-keys="modelTreeProp.defaultCheckedKey"
          @check="checkModelTree"
          @node-click="clickModelTree"
          @node-collapse="handleNodeCollapse"
        >
          <div
            class="custom-tree-node overflow-hidden w-full flex justify-between"
            slot-scope="{ node, data }"
          >
            <span class="text-12px">{{ data.name }}</span>
          </div>
        </el-tree>
      </div>
    </el-card>
  </div>
</template>
<script>
import { saveSceneToJson, isJSONObj, EnumObjectTypes } from '../../assets/js/scene/scene'
import setModelVisible from '../../assets/js/model/modelTree'

export default {
  name: 'NodeEditTree',
  mixins: [],
  props: ['location', 'player', 'customProps', 'loadModelStatus'],
  data() {
    return {
      addModelVisible: false,
      originPointOptionsVisible: false,
      originPointOptions: {
        id: '',
        name: '',
        longitude: '',
        latitude: '',
        folderId: '',
        isEnableGis: '',
      },
      showTemporaryImg: false,
      thumbnailUrl: '',
      imgChangeUrl: '',

      defaultProps: {
        label: 'name',
        children: 'zones',
      },
      treeShow: false,
      ableDelete: false,
      ableCreate: false,
      ableEdit: false,
      currentNodeData: {},
      currentTreeNode: null,
      defaultExpandedKeys: [],
      saveStatus: false,
      filterTreeKeyWords: '',
      loadType: '',
      loadPercentage: 0,
      showLoadProgress: false,
      engineerThumbnails: '',
      engineerName: '',
      isCreate: false,
      uploadLoading: false,
      exportPrName: '',
      // 模型树相关
      modelTreeProp: {
        currentNodeItem: 0, // 当前激活的node
        currentNodeName: '', // 点选时当前激活的节点名称
        treeData: [], // 模型树数据
        defaultCheckedKey: [], // 模型树选中的节点
        filterItem: [], // 模型树不需要显示的节点及他的父节点列表
        modelHideList: [], // 模型隐藏队列
        modelTreeLoadEnd: false, // 模型树数据加载完毕
      },
      saveDisable: false,
    }
  },
  watch: {
    'customProps.currentNodeData': {
      handler(data) {
        if (data && data.node) {
          this.currentNodeData = data
          // 展开树
          this.expendNode(data)
        }
      },
      deep: true,
      immediate: true,
    },
    async loadModelStatus(val) {
      if (val) {
        // 获取模型数据
        const rootNode = await this.player.Native.Node.getRoot()
        const currentProperty = await this.player.Native.Node.getProperty(rootNode, ['children'])
        this.modelTreeProp.treeData = currentProperty.children
        this.treeShow = true
      }
    },
  },
  async created() {
    if (this.loadModelStatus) {
      // 获取模型数据
      const rootNode = await this.player.Native.Node.getRoot()
      const currentProperty = await this.player.Native.Node.getProperty(rootNode, ['children'])
      this.modelTreeProp.treeData = currentProperty.children
      this.treeShow = true
    }
  },
  beforeDestroy() {},
  computed: {
    // 模型相关设置
    modelSetting() {
      return Wiz.globalSettings.globalConfig?.modelSetting || {}
    },
  },
  async mounted() {},
  methods: {
    // 设置gis原点

    // 收起节点
    handleNodeCollapse(data) {
      _.remove(this.defaultExpandedKeys, (item) => {
        return item === data.node
      })
    },

    // 展开节点
    handleNodeExpand(data) {
      this.defaultExpandedKeys.push(data.item)
    },
    async filterModelTree(startNode, KeyWords) {
      console.log(startNode, KeyWords, 'startNode, KeyWords----------------')

      // 过滤模型树
      const res = await this.player.Native.Node.findNode(startNode, {
        names: [KeyWords],
        codes: [KeyWords],
      })
      console.log(res, 'resresres--')

      const currentNodeData = res.codes
        ? res.codes[KeyWords] || {}
        : res.names
          ? res.names[KeyWords] || {}
          : {}
      // 展开树

      if (!_.isEmpty(currentNodeData)) {
        this.currentNodeData = currentNodeData
        await this.expendNode(this.currentNodeData, true)
      } else {
        // 未找到
        this.$message({
          showClose: true,
          message: '搜索结果到底了',
          type: 'error',
        })
      }
    },

    // 展开节点树
    async expendNode(node, doLocation) {
      const rootNode = await this.player.Native.Node.getRoot()
      const rootChild = await this.player.Native.Node.getProperty(rootNode, ['children'])
      console.log(node, '233333333333333333')

      if (node.node === rootChild.children[0]?.node) {
        // 到达根节点 执行点击事件
        this.$nextTick(() => {
          this.clickModelTree(this.currentNodeData, { checked: true }, doLocation)

          this.locationNode(this.currentNodeData.node)
        })
      } else {
        const res = await this.player.Native.Node.getProperty(node.node, ['parent'])
        const currentLevelNodes = await this.player.Native.Node.getProperty(res.parent, [
          'children',
        ])
        const parentInfo = await this.player.Native.Node.getProperty(res.parent, ['code', 'name'])
        let expandIndex = null
        if (currentLevelNodes.children?.length > 1000) {
          expandIndex = _.findIndex(currentLevelNodes.children, ['node', node.node])
        }
        await this.expendNode(parentInfo, doLocation)
        if (!this.defaultExpandedKeys.includes(parentInfo.node)) {
          // 展开
          this.defaultExpandedKeys.push(parentInfo.node)
        }
        if (!_.isNil(expandIndex) && expandIndex > -1) {
          this.defaultExpandedKeys.push(
            `${parentInfo.node}${
              expandIndex % 1000 === 0 ? expandIndex / 1000 : _.ceil(expandIndex / 1000) - 1
            }`
          )
        }
      }
    },

    // 模型树点击操作
    clickModelTree(data, node, doLocation) {
      if (data.isVirtual) {
        return
      }
      if (node && node.checked && doLocation) {
        this.multipleLocations(data)
        this.currentTreeNode = node
      }
      this.$refs.modelTree.setCurrentKey(data.node)
    },
    async multipleLocations(data) {
      if (
        data.code &&
        isJSONObj(data.code) &&
        ['Root', 'userData'].includes(JSON.parse(data.code).type)
      ) return
      // 高亮选中的模型
      const selectNodes = await this.player.Native.Node.getSeletedNodes()
      await this.player.Native.Node.unSelectNodes(selectNodes)
      this.player.Native.Node.selectNodes([data.node])
      this.player.Native.Camera.moveToNode(data.node, 2, 5)
    },
    // 查看当前节点是否没有在影藏队列
    isNoFindModelHides(nodeObj) {
      return (
        _.indexOf(
          _.map(this.modelTreeProp.modelHideList, (res1) => {
            return res1.item
          }),
          nodeObj.data.item
        ) === -1
      )
    },
    checkModelTree(data, checkeds) {
      // 节点选中状态发生变化
      const isChecked = _.includes(checkeds.checkedKeys, data.node)
      if (data.isVirtual) {
        this.$refs.modelTree.setCheckedKeys(this.modelTreeProp.defaultCheckedKey)
        return
      }
      setModelVisible(
        this.player,
        'checkModelTree',
        isChecked,
        [data.node],
        this.modelTreeProp,
        checkeds
      )
    },
    // 模型树懒加载
    async loadNode(node, resolve) {
      if (this.modelTreeProp.treeData.length === 0) {
        await this.getModelTreeDatas()
      }
      let tempFilterKeys = _.filter(this.modelTreeProp.treeData, (el) => {
        return this.modelTreeProp.filterItem.indexOf(el.node) === -1
      })
      if (node.level === 0) {
        this.modelTreeProp.defaultCheckedKey = _.map(tempFilterKeys, (val) => {
          return val.node
        })
        return resolve(this.modelTreeProp.treeData)
      }
      let res = []
      if (node.data.isVirtual) {
        res = node.data.childs
      } else {
        const result = await this.player.Native.Node.getProperty(node.data.node, ['children'])
        res = result?.children || []
      }
      const step = 200
      if (res.length > step) {
        const shardingRes = []
        for (let i = 0; i < _.ceil(res.length / step); i += 1) {
          shardingRes.push({
            name: `${i * step + 1}~${(i + 1) * step}`,
            checked: true,
            code: `${node.data.code}${i}`,
            node: `${node.data.node}${i}`,
            parentNode: node.data.node,
            visible: true,
            childs: res.slice(i * step, (i + 1) * step),
            isVirtual: true,
          })
        }
        res = shardingRes
      }
      const filterRes = _.filter(res, (el) => {
        return el?.name
      })
      // 控制模型树的选中按钮
      tempFilterKeys = _.filter(filterRes, (el) => {
        return this.modelTreeProp.filterItem.indexOf(el.node) === -1
      })
      const tempCheckedKey = _.map(tempFilterKeys, (val) => {
        return val.node
      })
      // 过滤勾选状态为选中的子集
      const checkedKeys = _.map(
        _.filter(filterRes, (res4) => {
          return res4.name
        }),
        (res5) => {
          return res5.node
        }
      )
      // 查看当前节点是否没有在隐藏队列
      // 保存this指向
      const _this = this
      const isNoFindModelHides = (nodeObj) => {
        return (
          _.indexOf(
            _.map(_this.modelTreeProp.modelHideList, (res1) => {
              return res1.node
            }),
            nodeObj.data.node
          ) === -1
        )
      }
      if (isNoFindModelHides(node)) {
        // 没有在隐藏队列中
        let node1 = node
        while (node1.level !== 0) {
          // 向上查找没有在隐藏队列的父辈节点
          if (isNoFindModelHides(node1)) {
            node1 = node1.parent
          } else {
            // 父级在隐藏队列就结束向上查找
            break
          }
        }
        if (node1.level === 0) {
          // 如果查找到跟节点都没有在隐藏队列中，那么就代表全是勾选状态，不存在半选
          this.modelTreeProp.defaultCheckedKey = [
            ...this.modelTreeProp.defaultCheckedKey,
            ...tempCheckedKey,
          ]
        } else if (_.some(filterRes, { checked: false })) {
          // 中间父级可能是半选或者空白
          // 通过父获取子集的状态,如果子集中有一个为false，那么就把父级从默认选中框中去除掉，然后在设置子集节点状态
          this.modelTreeProp.defaultCheckedKey = [
            ..._.filter(this.modelTreeProp.defaultCheckedKey, (val) => {
              return val !== node.data.node
            }),
            ...checkedKeys,
          ]
        }
      } else {
        // 在隐藏队列表
        this.modelTreeProp.defaultCheckedKey = [
          ...this.modelTreeProp.defaultCheckedKey,
          ...checkedKeys,
        ]
      }
      resolve(filterRes)
      _.forEach(filterRes, (el) => {
        if (this.currentNodeData.node) {
          if (el.node === this.currentNodeData.node) {
            setTimeout(() => {
              this.locationNode(this.currentNodeData.node)
            }, 1000)
          }
        }
      })
      if (this.modelTreeProp.defaultCheckedKey) {
        // this.treeShow = false
        // this.treeShow = true
        this.$nextTick(() => {
          if (this.$refs.modelTree) {
            this.$refs.modelTree.setCheckedKeys(this.modelTreeProp.defaultCheckedKey)
          }
        })
      }
    },
    // 定位树节点
    locationNode(id) {
      this.$nextTick(() => {
        this.$refs.modelTree.setCurrentKey(id)

        setTimeout(async () => {
          const node = document.getElementById('modelTree')
          const waitForCurrentNode = (interval = 100) => {
            return new Promise((resolve, reject) => {
              let attempts = 0
              const maxAttempts = 50 // 最多尝试50次，防止无限循环
              const checkNode = () => {
                const currentNode = document.getElementsByClassName('is-current')[0]
                if (currentNode) {
                  resolve(currentNode)
                } else if (attempts < maxAttempts) {
                  attempts += 1
                  setTimeout(checkNode, interval)
                } else {
                  reject(new Error('未能在规定时间内找到 is-current 元素'))
                }
              }

              checkNode()
            })
          }
          const currentNode = await waitForCurrentNode()
          currentNode?.offsetTop &&
            node.scrollTo({
              top: currentNode.offsetTop,
            })
        }, 50)
      })
    },
    async getModelTreeDatas() {
      // 加载模型完成后获取模型数据
      const rootNode = await this.player.Native.Node.getRoot()
      const currentProperty = await this.player.Native.Node.getProperty(rootNode, ['children'])
      this.modelTreeProp.treeData = currentProperty.children
      this.modelTreeProp.modelTreeLoadEnd = true
    },
    // 允许拖拽
    allowDrag(node) {
      return (
        node.data.code && isJSONObj(node.data.code) && JSON.parse(node.data.code).type !== 'Root'
      )
    },
    allowDrop(dragNode, dropNode) {
      return (
        dropNode.data.code &&
        isJSONObj(dropNode.data.code) &&
        !EnumObjectTypes.includes(JSON.parse(dropNode.data.code).type)
      )
    },
    // 拖拽结束
    async handleNodeDrop(beforeNode, afterNode) {
      this.player.Native.Node.setProperty(beforeNode.data.node, { parent: afterNode.data.node })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../assets/style/index';

.model-edit {
  background-color: rgba(0, 18, 55, 0.3) !important;
  border: none !important;
}

.menu-card {
  background-color: rgba(24, 41, 72, 0.8);

  .menu-item:hover {
    background-color: rgba(0, 116, 201, 0.4);
  }
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: #fff !important;
}

::v-deep .el-card {
  &__body {
    padding: 0 !important;
    height: calc(100% - 30px);
    background-color: rgba(24, 41, 72, 0.5) !important;
    border-radius: 2px;
  }
}

::v-deep .el-loading-mask {
  background-color: rgba(24, 41, 72, 0.8) !important;
}

::v-deep .el-tree {
  height: 100% !important;
}

::v-deep .el-card .el-card__header {
  background: transparent !important;
}

::v-deep .el-button.el-tooltip {
  padding: 0 !important;
  width: 25px !important;
  height: 25px !important;
  line-height: 1 !important;
}

::v-deep .el-input-group__append {
  padding: 0;

  .el-button {
    margin: 0 !important;
    color: #fff !important;
    background-color: #46a6ff !important;
    border-color: #46a6ff !important;

    .iconfont {
      font-size: 14px !important;
    }
  }

  .el-button:nth-child(2) {
    margin-left: 1px !important;
  }
}

#rotateImg {
  transform: rotateX(180deg);
}
</style>
